<template>
  <b-card>
    <div class="content-header-card flex-wrap d-flex justify-content-center">
      <div class="content-header-name mb-1 mb-md-0">
        <div>{{ $props.configCard.name }}</div>
      </div>
      <!-- <div class="p-relative today-picker">
        <clock-svg class="icon-clock" />
        <v-select id="filter-day" placeholder="Today" />
      </div> -->
    </div>

    <div class="content-body-card mt-2">
      <div class="date-select">
        <div class="p-relative w-45 ">
          <calendar-svg class="icon-calendar bypass" />
          <flat-pickr
            id="filter-date-bi"
            class="form-control"
            :config="{
              altInput: true,
              altFormat: 'F j, Y',
              dateFormat: 'Y-m-d',
            }"
            placeholder="Start date"
            :value="''"
            @on-change="handleChangeFromDate"
          />
        </div>
        <div class="space-to">to</div>
        <div class="p-relative w-45">
          <calendar-svg class="icon-calendar bypass" />
          <flat-pickr
            id="filter-date-bi"
            class="form-control"
            :config="{
              altInput: true,
              altFormat: 'F j, Y',
              dateFormat: 'Y-m-d',
            }"
            placeholder="End date"
            :value="''"
            @on-change="handleChangeToDate"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BCardHeader } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";

import ClockSvg from "@/@core/components/svg/filter-card/Clock.vue";
import CalendarSvg from "@/@core/components/svg/filter-card/Calendar.vue";
import { getCurrentInstance, reactive, watch } from "@vue/composition-api";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    vSelect,
    flatPickr,
    ClockSvg,
    CalendarSvg,
    BCardHeader,
  },
  props: {
    configCard: Object,
  },
  setup() {
    const vm = getCurrentInstance().proxy;
    const filter = reactive({
      from: null,
      to: null,
    });
    const handleChangeFromDate = (e) => {
      let date = e[0].toLocaleDateString("en-US")
      date = date.split("/")
      filter.from = date[1].padStart(2, "0") + "/" + date[0].padStart(2, "0") + "/" + date[2]
    };

    const handleChangeToDate = (e) => {
      let date = e[0].toLocaleDateString("en-US")
      date = date.split("/")
      filter.to = date[1].padStart(2, "0") + "/" + date[0].padStart(2, "0") + "/" + date[2]
    };

    watch(filter, () => {
      vm.$emit("fetchDynamicBi", filter.from, filter.to);
    },{deep : true})

    return {
      handleChangeFromDate,
      handleChangeToDate,
    };
  },
};
</script>

<style scoped>
.content-header-card {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.content-header-name > div {
  font-size: 3.4rem;
  line-height: 1;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
